<script>
import bem from '@/utils/bem';
import convertToPrice from '@/utils/convertToPrice';

const b = bem('before-after-price');
export default {
  props: {
    price: Number,
    additionalDiscount: Number,
    textBefore: String,
    textAfter: String,
    isRow: Boolean,
    withoutPrice: Boolean,
    textBeforeClassName: String,
    textAfterClassName: String,
    priceClassName: String,
    priceAfterClassName: String,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    convertToPrice,
  },
};

</script>

<template>
  <div :class="b('price-wrapper', { column: !isRow })">
    <span
        :class="b('price-text', { mix: textBeforeClassName })"
        v-if="textBefore"
    >
      {{textBefore}}
    </span>
    <div :class="b('price-values', { row: isRow })" v-if="!withoutPrice">
      <template v-if="additionalDiscount">
        <span
            :class="b('price',
            { 'origin-column': !isRow, 'origin-row': isRow, row: isRow, mix: priceClassName })"
        >
          {{convertToPrice(price)}}
      </span>
      <span :class="b('price', { custom: true, row: isRow, mix: priceAfterClassName  })">
        {{convertToPrice(price - additionalDiscount)}}
        </span>
      </template>
      <span
          :class="b('price', { custom: true, row: isRow, mix: priceClassName  })"
          v-else
      >
        {{convertToPrice(price - additionalDiscount)}}
      </span>
    </div>
      <span
          :class="b('price-text', { mix: textAfterClassName })"
          v-if="textAfter"
      >
        {{textAfter}}
      </span>
  </div>
</template>

<style scoped lang="scss" src="./style.scss"></style>
